import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function CommonAccordion({ title, bottomBorder, renderLeftIcon, renderRightPart, children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`bo-common-accordion ${bottomBorder ? 'bo-common-accordion-bottom-border' : ''}`}
    >
      <Button className="bo-common-accordion-top-section" onClick={() => setIsOpen(!isOpen)}>
        <div className="bo-common-accordion-icon">
          <FontAwesomeIcon icon={isOpen ? faAngleDown : faAngleRight} size="sm" color="black" />
        </div>
        {renderLeftIcon && renderLeftIcon(isOpen)}
        <p className="bo-common-text-bold">{title}</p>
        {renderRightPart && renderRightPart(isOpen)}
      </Button>
      {isOpen && <div className="bo-common-accordion-content">{children}</div>}
    </div>
  );
}

export default CommonAccordion;
